<template>
  <div class="content-container">
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">
                {{ $t('views.report.stayingGuestReport') }}
              </span>
            </div>
            <div class="flex" style="gap: 10px">
              <InfoBtn @click="noteDialogVisible = true" />

              <el-dropdown trigger="click" @command="onClickDropdownItem">
                <das-button
                  color="primary"
                  size="medium"
                  :rounded="false"
                  outline
                  icon
                >
                  <i class="el-icon-download"></i>
                </das-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">
                    {{ $t('button.exportPdf') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="excel">
                    {{ $t('button.exportExcel') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <hr />

          <div v-loading="gridLoading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :default-col-def="defaultColDef"
              :rows="rows"
              dom-layout="scroll"
              class="agGrid"
              :auto-size-cell="true"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('dialog.titleNote')"
      :visible.sync="noteDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="note-container">
            <ul class="">
              <li>STT: hiển thị số thứ tự</li>
              <li>Recode: Hiển thị mã đặt phòng</li>
              <li>Phòng: Hiển thị số phòng</li>
              <li>Tên Khách : Tên khách chính của phòng</li>
              <li>
                Thời gian CI: Thời gian khách đã CI. Format:DD/MM/YYYY HH:MM:SS
              </li>
              <li>
                Thời gian CO: Thời gian dự kiến check out. DD/MM/YYYY HH:MM:SS
              </li>
              <li>Số lượng khách: Tổng số người lớn + trẻ em</li>
            </ul>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="noteDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DasButton from '@/components/ui/DasButton.vue'
import InfoBtn from './components/InfoBtn.vue'
import {
  getInHouseGuestReportApi,
  getInHouseGuestReportExcel
} from '@/api/report_service/report'

export default {
  components: {
    DasButton,
    InfoBtn
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      noteDialogVisible: false,
      searchParams: {},
      gridLoading: false,
      columns: [
        {
          headerName: this.$t('grid.column.numericalOrder'),
          field: 'no',
          // cellClass: "grid-cell-centered",
          minWidth: 70,
          maxWidth: 80,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.recode'),
          field: 'booking_code',
          tooltipField: 'booking_code',
          // cellClass: "grid-cell-centered",
          // width: 100,
          flex: 1,
          minWidth: 100,
          maxWidth: 200,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.room'),
          field: 'room_num',
          tooltipField: 'room_num',
          flex: 1,
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.mainGuestNameOfRoom'),
          field: 'traveller_name',
          tooltipField: 'traveller_name',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          flex: 1,
          minWidth: 250
        },
        {
          headerName: this.$t('grid.column.checkinTime'),
          field: 'ci_at',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 180,
          maxWidth: 180
        },
        {
          headerName: this.$t('grid.column.checkoutTimeExpected'),
          field: 'expect_co_at',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 180,
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.numOfGuest'),
          field: 'num_of_guest',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 100,
          maxWidth: 150
        }
      ],
      rows: []
    }
  },
  mounted() {
    this.attachData()
  },
  methods: {
    onSearch() {},
    onReset() {},
    onClickDropdownItem(cmd) {
      if (cmd === 'excel') {
        getInHouseGuestReportExcel().then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'in_house_guest_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },
    attachData() {
      this.gridLoading = true
      getInHouseGuestReportApi()
        .then(res => {
          this.rows = res.data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading = false
        })
    }
  }
}
</script>

<style></style>
